import { observer } from 'mobx-react';
import React from 'react';

import { Button, CircularProgress, Dialog } from '@mui/material';

import useStores from 'hooks/use-stores';
import { useStartTrial } from 'queries/license/use-start-trial';

import useStyles from './styles';

interface Props {
    open: boolean;
    onClose?: () => void;
    className?: string;
}

const StartTrialDialog: React.FC<Props> = ({ open, onClose, className }) => {
    const { classes } = useStyles();

    const { userStore } = useStores();
    const { mutate, isPending } = useStartTrial({
        onSuccess: () => {
            onClose?.();
            userStore.loadLicenseList();
        }
    });

    return (
        <Dialog
            open={open}
            keepMounted={false}
            TransitionProps={{ mountOnEnter: true, unmountOnExit: true }}
            className={className}
            slotProps={{ backdrop: { className: classes.backdrop } }}
            classes={{
                root: classes.root,
                paper: classes.paper
            }}
        >
            <p className={classes.title}>{'Starting Trial License'}</p>
            <p className={classes.content}>{'Are you sure want to start 30-days Trial Period?'}</p>
            <div className={classes.actions}>
                <Button
                    onClick={onClose}
                    disabled={isPending}
                    variant="contained"
                    centerRipple
                    disableElevation
                    disableFocusRipple
                    className={classes.cancel}
                    fullWidth
                >
                    {'Cancel'}
                </Button>
                <Button
                    onClick={() => mutate(undefined)}
                    autoFocus
                    startIcon={isPending ? <CircularProgress color="inherit" size={14} /> : null}
                    disabled={isPending}
                    variant="outlined"
                    centerRipple
                    disableElevation
                    disableFocusRipple
                    className={classes.submit}
                    fullWidth
                >
                    {'Start free trial'}
                </Button>
            </div>
        </Dialog>
    );
};

export default observer(StartTrialDialog);
